export default "__VITE_ASSET__hOEa6dY8__"